import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";

import Img from "../../common/Img";

import db from "../../../services/query";

import { PopUpContext } from "../../../contexts/popUpContext";

import ReportItemList from "./ReportItemList";
import ReportItemHeader from "../../common/ReportItemHeader";
import ResultList from "./ResultList";
import MainPrintLink from "../../common/MainPrint";
import TranscriptFaIcon from "../../../icons/transcript-fa-icon";

const ResultProfile = (props) => {
  const { sid } = props.match.params;

  const [activeSem, setSem] = useState(0);
  const [data, updateData] = useState([]);

  const { popUp } = useContext(PopUpContext);

  useEffect(async () => {
    const ac = new AbortController();
    requestData();
    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `results/students/${sid}`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="results-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.student_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary results">
          <div className="wrapper">
            <p>{lbl.OverallPercentage}</p>
            <h5>{`${data?.summary?.overall_percentage || '.'}%`}</h5>
          </div>
          <div className="wrapper">
            <p>{lbl.OverallCredits}</p>
            <h5>{`${data?.summary?.overall_credits || '-'}`}</h5>
          </div>
          <div className="wrapper">
            <p>{lbl.OverallMarks}</p>
            <h5>{`${data?.summary?.overall_marks || '-'}`}</h5>
          </div>
          <div className="wrapper">
            <p>{lbl.OverallGPA}</p>
            <h5>{`${data?.summary?.overall_gpa || '-'}`}</h5>
          </div>
        </div>
        <div style={{display: "flex", marginLeft: "20px"}} className="controls">
          <MainPrintLink path={`results/exam-result/${sid}/${activeSem}`} />
          
          {/*<MainPrintLink path={`transcript/${sid}?lang=fa`} icon={<TranscriptFaIcon />} title={"چاپ ترانسکرپت فارسی"}/>*/}
          <MainPrintLink path={`transcript/${sid}?lang=en`} icon={<TranscriptFaIcon />}  title={"چاپ ترانسکرپت انگلیسی"}/>
        </div>
      </div>
      <div className="results-report-area">
        <div className="report-container _75-per">
          <div className="report-table-area results">
            <ResultList activeSem={data?.data && data.data[activeSem]} />
          </div>
          <div className="student-info results">
            <div className="main-content-header">
              <div className={"right-content summary-card"}>
                <p className="summary-title">{"خلاصه سمستر" }</p>
              </div>
            </div>
            <div className="student-detail">
              <div className="detail_item">
                <p>مجموع کردت</p>
                <p>{data?.data && data?.data[activeSem]?.credits || '-' }</p>
              </div>
              <div className="detail_item">
                <p>مجموع نمرات</p>
                <p>{data?.data && data?.data[activeSem]?.total  || '-'}</p>
              </div>
              <div className="detail_item">
                <p>اوسط نمرات</p>
                <p>{data?.data && data?.data[activeSem]?.percentage  || '-'}</p>
              </div>
              <div className="detail_item">
                <p>CGPA</p>
                <p>{data?.data && data?.data[activeSem]?.GPA  || '-'}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="report-container _25-per">
          <ReportItemHeader title={lbl.Semester} />
          <ReportItemList data={data} setSem={setSem} activeSem={activeSem} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResultProfile;
